module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAxElEQVR4Ae2WAQbEMBBFH9q7BRTMIZfSZdWerdHYLBUB6DcMVF4B0v9IZiZhMBg8mIkVQ8VYmdBhZqdSRIVRqOzMyHyo11dYuGOhtNUbMoncfjpvFAtnW5lJ4Ff443WFHq8rzq5I/nh9h3W5XyFvn1/hj1cqPZMc8QLWFQdZb0KXoscbIrriFxkPRvEL4rdIrqODQz9kXyfoZRrfaPGjIn7YxY/r+Asn/soU4vVJK/NGbybrii324fVljnw6vpgYDAaP5Q+VUAhd26I5GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_close_black_24dp.png
// module id = 129
// module chunks = 0